import { Card, Stack, Avatar, CardHeader, Typography } from "@mui/material";
import GppGoodRoundedIcon from "@mui/icons-material/GppGoodRounded";

export default function AllRoles({ data }) {
  return (
    <Stack rowGap={1} width="100%">
      {data.map((item, i) => {
        const { role, units, shops } = item;
        if (shops) {
          return shops.map(({ id, title }, i) => (
            <Card key={i} sx={{ width: "100%", bgcolor: "action.hover" }}>
              <CardHeader
                sx={{ py: 1 }}
                avatar={
                  <Avatar
                    sx={{ bgcolor: "action.selected", width: 28, height: 28 }}
                  >
                    <GppGoodRoundedIcon fontSize="small" color="warning" />
                  </Avatar>
                }
                title={
                  <Typography variant="subtitle1" fontSize={12} color="#fff">
                    {role.title}
                  </Typography>
                }
                action={
                  <Typography variant="caption" fontSize={12} color="#fff">
                    {title}
                  </Typography>
                }
              />
            </Card>
          ));
        }
        if (units) {
          return units
            .filter((x) => x)
            .map(({ id, title }, i) => (
              <Card key={i} sx={{ width: "100%", bgcolor: "action.hover" }}>
                <CardHeader
                  sx={{ py: 1 }}
                  avatar={
                    <Avatar
                      sx={{ bgcolor: "action.selected", width: 28, height: 28 }}
                    >
                      <GppGoodRoundedIcon fontSize="small" color="warning" />
                    </Avatar>
                  }
                  title={
                    <Typography variant="subtitle1" fontSize={12} color="#fff">
                      {role.title}
                    </Typography>
                  }
                  action={
                    <Typography variant="caption" fontSize={12} color="#fff">
                      {title}
                    </Typography>
                  }
                />
              </Card>
            ));
        }
        return (
          <Card key={i} sx={{ width: "100%", bgcolor: "action.hover" }}>
            <CardHeader
              sx={{ py: 1 }}
              avatar={
                <Avatar
                  sx={{ bgcolor: "action.selected", width: 28, height: 28 }}
                >
                  <GppGoodRoundedIcon fontSize="small" color="warning" />
                </Avatar>
              }
              title={
                <Typography variant="subtitle1" fontSize={12} color="#fff">
                  {role.title}
                </Typography>
              }
              // action={
              //   <Typography variant="caption" fontSize={12} color="#fff">
              //     {title}
              //   </Typography>
              // }
            />
          </Card>
        );
      })}
    </Stack>
  );
}
